export const FileActionTypes = {
    UPLOAD_AVATAR_REQUEST: "@@File/UPLOAD_AVATAR_REQUEST",
    UPLOAD_AVATAR_SUCCESS: "@@File/UPLOAD_AVATAR_SUCCESS",
    UPLOAD_AVATAR_FAILURE: "@@File/UPLOAD_AVATAR_FAILURE",

    UPLOAD_LIVES_REQUEST: "@@File/UPLOAD_LIVES_REQUEST",
    UPLOAD_LIVES_SUCCESS: "@@File/UPLOAD_LIVES_SUCCESS",
    UPLOAD_LIVES_FAILURE: "@@File/UPLOAD_LIVES_FAILURE",

    UPLOAD_PRODUCTS_REQUEST: "@@File/UPLOAD_PRODUCTS_REQUEST",
    UPLOAD_PRODUCTS_SUCCESS: "@@File/UPLOAD_PRODUCTS_SUCCESS",
    UPLOAD_PRODUCTS_FAILURE: "@@File/UPLOAD_PRODUCTS_FAILURE",

    GET_CONFIGURATION_REQUEST: "@@File/GET_CONFIGURATION_REQUEST",
    GET_CONFIGURATION_SUCCESS: "@@File/GET_CONFIGURATION_SUCCESS",
    GET_CONFIGURATION_FAILURE: "@@File/GET_CONFIGURATION_FAILURE",

    UPLOAD_PROFILEIMAGE_REQUEST: "@@File/UPLOAD_PROFILEIMAGE_REQUEST",
    UPLOAD_PROFILEIMAGE_SUCCESS: "@@File/UPLOAD_PROFILEIMAGE_SUCCESS",
    UPLOAD_PROFILEIMAGE_FAILURE: "@@File/UPLOAD_PROFILEIMAGE_FAILURE",

    GET_ATTACHMENTS_REQUEST: "@@File/GET_ATTACHMENTS_REQUEST",
    GET_ATTACHMENTS_SUCCESS: "@@File/GET_ATTACHMENTS_SUCCESS",
    GET_ATTACHMENTS_FAILURE: "@@File/GET_ATTACHMENTS_FAILURE",
};
